import { gradientStyleFactory } from "../../util/gradientStyleFactory.ts";

export const ratingsGradientStyle = gradientStyleFactory(25, 45, 55, 75);
